// @ts-nocheck
// Call Stats filter — segmented preset control + a single calendar range
// popover, all on one row. Presets use the shadcn Tabs primitive rather
// than hand-rolled buttons: TabsList/TabsTrigger are already styled as a
// segmented control in this project and bring keyboard + ARIA roles for
// free. The range uses the shared DateRangePicker (Popover + range
// Calendar) instead of two bare native date inputs, so there's one control
// and one mental model.
//
// This was previously one of two switchable designs (the other, a
// Voicemails-style labeled grid, has been retired — this one's it).
import React from 'react';
import { FiRefreshCw, FiRotateCcw } from 'react-icons/fi';
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DateRangePicker } from '@/components/ui/date-range-picker';
import { PRESETS } from '../format';

export default function FilterBarPill({
  activePreset,
  startDate,
  endDate,
  onPresetChange,
  onRangeChange,
  onReset,
  onRefresh,
  rangeLabel,
  extra,
}: any) {
  const today = React.useMemo(() => new Date(), []);
  const minDate = React.useMemo(() => {
    const d = new Date(today);
    d.setHours(0, 0, 0, 0);
    d.setMonth(d.getMonth() - 3);
    return d;
  }, [today]);

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Tabs value={activePreset || ''} onValueChange={onPresetChange}>
        <TabsList className="h-8 rounded-full bg-muted/60 p-1">
          {PRESETS.map((preset) => (
            <TabsTrigger
              key={preset.key}
              value={preset.key}
              className="rounded-full px-3 py-0.5 text-[11px] font-medium data-[state=active]:shadow-sm"
            >
              {preset.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <DateRangePicker
        value={{ from: startDate, to: endDate }}
        onChange={onRangeChange}
        fromDate={minDate}
        toDate={today}
        displayFormat="d MMM"
        numberOfMonths={2}
        placeholder="Custom range"
        className="h-8 w-auto rounded-full border-border bg-muted/60 px-3 text-[11px]"
        contentClassName="z-[1100]"
      />

      {rangeLabel ? (
        <span className="hidden text-[11px] text-muted-foreground xl:inline">{rangeLabel}</span>
      ) : null}

      {extra}

      <div className="ml-auto flex items-center gap-1.5">
        <Button
          size="sm"
          variant="ghost"
          onClick={onReset}
          title="Reset to this month"
          className="h-8 w-8 rounded-full p-0 text-muted-foreground hover:text-foreground"
        >
          <FiRotateCcw size={13} />
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={onRefresh}
          title="Refresh all"
          className="h-8 w-8 rounded-full p-0 text-muted-foreground hover:text-foreground"
        >
          <FiRefreshCw size={13} />
        </Button>
      </div>
    </div>
  );
}
